import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import { additionalDischargeRoutes } from '@/features/additional-discharges';
import { authRoutes } from '@/features/auth';
import { communicationRoutes } from '@/features/communication';
import { contractsRoutes } from '@/features/contracts';
import { desktopRoutes } from '@/features/desktop';
import { invoicesRoutes } from '@/features/invoices';
import { mainRoutes } from '@/features/main';
import { reportsRoutes } from '@/features/reports';
import { routeGroupItemsRoutes } from '@/features/route-group-items';
import { serviceHistoryRoutes } from '@/features/service-history';
import AppLayout from '@/layouts/AppLayout';

const router = createBrowserRouter([
  {
    element: <AppLayout />,
    children: [
      ...mainRoutes,
      ...authRoutes,
      ...invoicesRoutes,
      ...reportsRoutes,
      ...contractsRoutes,
      ...communicationRoutes,
      ...routeGroupItemsRoutes,
      ...serviceHistoryRoutes,
      ...desktopRoutes,
      ...additionalDischargeRoutes,
    ],
  },
]);

export default router;
